import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import Swal from 'sweetalert2';
/**Modelo */
import { Equipo } from 'src/app/administracion/modelos/Inventario/Equipo/equipo';
/** Servicios */
import { ActivatedRoute } from '@angular/router';
import { EquipoService } from 'src/app/administracion/servicios/Inventario/Equipo/equipo.service';
import { Router } from '@angular/router';
import { UsuarioService } from 'src/app/administracion/servicios';
import { Usuario } from 'src/app/administracion/modelos';
import { Empleado } from 'src/app/administracion/modelos/empleado';
import { Subject } from 'rxjs';
import { distinctUntilChanged, finalize, takeUntil } from 'rxjs/operators';
import { Dispositivos } from 'src/app/administracion/enums/disposivios.enum';
import { CONFIGURACION_DISPOSITIVOS } from 'src/app/administracion/constants/configuracion-dispositivos.const';
import { EstadoGestionEquipo, Paginacion } from './estado-gestion-equipo';
import { EstadosEquipos } from 'src/app/administracion/enums/estados-equipos.enum';
import { ESTADOS_EQUIPOS } from 'src/app/administracion/constants/estados-equipos.const';
/** */

interface ConfiguracionDispositivo {
  tabla: string;
  tablaTipo: string;
  tablaModelo: string;
  tipoField: string;
  modeloField: string;
  detalleRuta: string;
}

@Component({
  selector: 'app-gestion-equipo',
  templateUrl: './gestion-equipo.component.html',
  styleUrls: ['./gestion-equipo.component.scss'],
})
export class GestionEquipoComponent implements OnInit, OnDestroy {
  private readonly onDestroy$ = new Subject<void>();

  tabla: string = '';
  tablaTipo: string = '';
  tablaModelo: string = '';
  empleado: Empleado = new Empleado();

  /** Select */
  dispositivoSeleccionadoControl = new FormControl();

  readonly dispositivos: string[] = Object.values(Dispositivos);

  private readonly configuracionDispositivos = CONFIGURACION_DISPOSITIVOS;

  /** Tablas */
  encabezadostabla: string[] = [
    'opciones',
    'nombre',
    'numSerie',
    'tipo',
    'modelo',
    'fabricante',
    'sucursalStatus',
    'fecha_mod',
  ];

  estadosEquipos = {
    Todos: new EstadoGestionEquipo([]),
    Asignados: new EstadoGestionEquipo(ESTADOS_EQUIPOS.Asignados),
    NoAsignados: new EstadoGestionEquipo(ESTADOS_EQUIPOS['No asignados']),
    Baja: new EstadoGestionEquipo(ESTADOS_EQUIPOS.Baja),
  };

  constructor(
    private equipoService: EquipoService,
    private router: Router,
    private activeRouter: ActivatedRoute,
    private usuarioService: UsuarioService,
  ) {}

  ngOnInit() {
    this.mostrarToastEleccion();

    this.onDispositivoSeleccionado();

    this.activeRouter.params.subscribe((params) => {
      this.dispositivoSeleccionadoControl.setValue(params['nomActivo']);
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  /** Evento cuando el usuario selecciona un dispositivo en el select */
  onDispositivoSeleccionado() {
    this.dispositivoSeleccionadoControl.valueChanges
      .pipe(distinctUntilChanged(), takeUntil(this.onDestroy$))
      .subscribe(() => {
        this.seleccionarTipoDispositivo();
      });
  }

  private mostrarToastEleccion() {
    Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
    }).fire({
      icon: 'info',
      title:
        'Elija un tipo de activo para poder visualizar los equipos existentes en la base de datos de GLPI.',
    });
  }

  private obtenerConfiguracionDispositivoSeleccionado():
    | ConfiguracionDispositivo
    | undefined {
    const dispositivoSeleccionado = this.dispositivoSeleccionadoControl
      .value as Dispositivos;
    return this.configuracionDispositivos[dispositivoSeleccionado];
  }

  private asignarTipoYModelo(element: Equipo) {
    const configuracion = this.obtenerConfiguracionDispositivoSeleccionado();
    if (!configuracion) {
      return;
    }

    const equipo = element as any;
    element.tipo = equipo[configuracion.tipoField];
    element.modelo = equipo[configuracion.modeloField];
  }

  private cargarTablasPorDispositivo() {
    this.resetTablas();
    this.llenarDataTodos();
  }

  private resetTablas() {
    this.estadosEquipos.Todos.data = [];
    this.estadosEquipos.Asignados.data = [];
    this.estadosEquipos.NoAsignados.data = [];
    this.estadosEquipos.Baja.data = [];

    this.estadosEquipos.Todos.paginacion = new Paginacion(0, 20, 0);
    this.estadosEquipos.Asignados.paginacion = new Paginacion(0, 20, 0);
    this.estadosEquipos.NoAsignados.paginacion = new Paginacion(0, 20, 0);
    this.estadosEquipos.Baja.paginacion = new Paginacion(0, 20, 0);
  }

  private cargarDataPorFiltro(
    estado: EstadoGestionEquipo,
    normalizador?: (equipo: Equipo) => void,
  ) {
    if (estado.estado === 'cargando') {
      return;
    }

    estado.estado = 'cargando';

    this.equipoService
      .obtenerEquipos(
        this.tabla,
        {
          page: estado.paginacion.page,
          size: estado.paginacion.size,
        },
        { estatus: estado.estados },
      )
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (equipos) => {
          estado.estado = 'exito';

          const listaAux: Equipo[] = [];

          equipos.content.forEach((equipo) => {
            normalizador?.(equipo);
            this.asignarTipoYModelo(equipo);
            listaAux.push(equipo);
          });

          estado.paginacion.totalElements = equipos.totalElements;
          estado.paginacion.page = equipos.number;
          estado.paginacion.size = equipos.size;

          estado.data = listaAux;
        },
        (err) => {
          Swal.fire({
            position: 'center',
            icon: 'error',
            text: 'Los equipos no se pueden visualizar debido a que no hay conexión con el servidor, inténtelo más tarde o contacte al área de T.I. ',
            title: 'Alta de equipos',
          });
          estado.estado = 'error';
        },
      );
  }

  private normalizarUsuarioAsignado(equipo: Equipo) {
    this.usuarioService
      .getUsernamePrueba(equipo.users_id + '')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((usuarioApi) => {
        const usuario = usuarioApi as Usuario;
        this.empleado = usuario.empleado;
        equipo.users_id =
          this.empleado.nombre +
          ' ' +
          this.empleado.apellidoPat +
          ' ' +
          this.empleado.apellidoMat;
        console.log(equipo.users_id + 'nom');
      });
  }

  /** Llena el data de todos los dispositivos segun sea el activo seleccionado */
  llenarDataTodos() {
    if (this.estadosEquipos.Todos.estado === 'cargando') {
      return;
    }

    this.estadosEquipos.Todos.estado = 'cargando';

    this.equipoService
      .obtenerEquipos(this.tabla, {
        page: this.estadosEquipos.Todos.paginacion.page,
        size: this.estadosEquipos.Todos.paginacion.size,
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (equipos) => {
          this.estadosEquipos.Todos.estado = 'exito';
          const listaAux: Equipo[] = [];
          equipos.content.forEach((element) => {
            this.asignarTipoYModelo(element);
            listaAux.push(element);
          });

          this.estadosEquipos.Todos.paginacion.totalElements =
            equipos.totalElements;
          this.estadosEquipos.Todos.paginacion.page = equipos.number;
          this.estadosEquipos.Todos.paginacion.size = equipos.size;

          this.estadosEquipos.Todos.data = listaAux;
        },
        (err) => {
          Swal.fire({
            position: 'center',
            icon: 'error',
            text: 'Los equipos no se pueden visualizar debido a que no hay conexión con el servidor, inténtelo más tarde o contacte al área de T.I. ',
            title: 'Alta de equipos',
          });
          this.estadosEquipos.Todos.estado = 'error';
        },
      );
  }

  /** Llena el data de todos los dispositivos Asignados según sea el activo seleccionado*/
  llenarDataAsignados() {
    this.cargarDataPorFiltro(this.estadosEquipos.Asignados, (equipo) =>
      this.normalizarUsuarioAsignado(equipo),
    );
  }

  /** Llena el data de todos los dispositivos en Almacén según sea el activo seleccionado*/
  llenarDataNoAsignados() {
    this.cargarDataPorFiltro(this.estadosEquipos.NoAsignados);
  }

  /** Llena el data de todos los dispositivos en estado de Baja según sea el activo seleccionado*/
  llenarDataBaja() {
    this.cargarDataPorFiltro(this.estadosEquipos.Baja);
  }

  /** Evento del tab */
  myTabSelectedIndexChange(index: number) {
    if (index == 1 && this.estadosEquipos.Asignados.data.length == 0) {
      this.llenarDataAsignados();
    } else if (index == 2 && this.estadosEquipos.NoAsignados.data.length == 0) {
      this.llenarDataNoAsignados();
    } else if (index == 3 && this.estadosEquipos.Baja.data.length == 0) {
      this.llenarDataBaja();
    }
  }

  onPageTodos(event: PageEvent) {
    this.estadosEquipos.Todos.paginacion.page = event.pageIndex;
    this.estadosEquipos.Todos.paginacion.size = event.pageSize;
    this.llenarDataTodos();
  }

  onPageAsignados(event: PageEvent) {
    this.estadosEquipos.Asignados.paginacion.page = event.pageIndex;
    this.estadosEquipos.Asignados.paginacion.size = event.pageSize;
    this.llenarDataAsignados();
  }

  onPageNoAsignados(event: PageEvent) {
    this.estadosEquipos.NoAsignados.paginacion.page = event.pageIndex;
    this.estadosEquipos.NoAsignados.paginacion.size = event.pageSize;
    this.llenarDataNoAsignados();
  }

  onPageBaja(event: PageEvent) {
    this.estadosEquipos.Baja.paginacion.page = event.pageIndex;
    this.estadosEquipos.Baja.paginacion.size = event.pageSize;
    this.llenarDataBaja();
  }

  /** Botones*/
  /** Envia a la vista de detalle equipo  */
  botonVerADetalle(id_equipo: number) {
    this.router.navigate([
      'layout/detalleEquipo/' +
        id_equipo +
        '/' +
        this.dispositivoSeleccionadoControl.value,
    ]);
  }

  /** Select tipo de activo y se le asignan los nombres de las tablas segun corresponda */
  seleccionarTipoDispositivo() {
    const configuracion = this.obtenerConfiguracionDispositivoSeleccionado();
    if (!configuracion) {
      return;
    }

    this.tabla = configuracion.tabla;
    this.tablaTipo = configuracion.tablaTipo;
    this.tablaModelo = configuracion.tablaModelo;
    this.cargarTablasPorDispositivo();
  }

  /**Redireccionara al detalle del equipo pasandole su id */
  detalleEquipo(id_equipo: number) {
    const configuracion = this.obtenerConfiguracionDispositivoSeleccionado();
    if (!configuracion) {
      return;
    }

    this.router.navigate([
      'layout/detalleEquipo/' + id_equipo + '/' + configuracion.detalleRuta,
    ]);
  }

  /**Metódo que muestra la información de ayuda */
  botonInformacion() {
    Swal.fire({
      position: 'top-end',
      icon: 'info',
      title: 'GESTIÓN DE EQUIPOS',
      showConfirmButton: false,
      html:
        '<p align="justify">Para poder visualizar los equipos existentes, deberá elegir un tipo de activo. \n</p>' +
        '<p align="justify">Posteriormente podrá visualizar todos los equipos de esa categoría y además visualizarlos por el estatus en el que se encuentre. \n</p>',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
    });
  }
}
